import React, { lazy } from 'react';
import { CheckCircle2, Award, Heart, Users, Target, Handshake } from 'lucide-react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
export function AboutSection() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-21">
      <div className="container mx-auto px-4" data-id="element-22">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-20" data-id="element-23">
          {/* Content */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-24">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4 animate-fadeIn" data-id="element-25">
              Who We Are
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-charcoal mb-6 leading-tight animate-fadeInUp animation-delay-100" data-id="element-26">
              Dedicated to Improving Lives & Strengthening Communities
            </h2>
            <p className="text-neutral-600 text-lg mb-8 leading-relaxed animate-fadeInUp animation-delay-200" data-id="element-27">
              The Senator Fatimat Raji Rasaki Foundation (SFRR Foundation) is a
              non-profit, non-political organization dedicated to improving
              lives and strengthening communities across Nigeria.
            </p>
            <p className="text-neutral-600 text-lg mb-8 leading-relaxed animate-fadeInUp animation-delay-300" data-id="element-28">
              We work to address critical social challenges by implementing
              impactful programs in agriculture, healthcare, education,
              humanitarian response, and social empowerment. Our focus is on
              reaching the most vulnerable populations and creating pathways to
              dignity, opportunity, and long-term resilience.
            </p>

            <div className="space-y-4 mb-10 animate-fadeInUp animation-delay-400" data-id="element-29">
              {[{
              icon: <Users className="w-5 h-5" data-id="element-30" />,
              text: 'Reaching the most vulnerable populations with dignity and care'
            }, {
              icon: <Heart className="w-5 h-5" data-id="element-31" />,
              text: 'Implementing sustainable programs in agriculture, healthcare, and education'
            }, {
              icon: <Handshake className="w-5 h-5" data-id="element-32" />,
              text: 'Building strategic partnerships with government, donors, and communities'
            }, {
              icon: <Target className="w-5 h-5" data-id="element-33" />,
              text: 'Creating practical, inclusive, and sustainable solutions'
            }].map((item, index) => <div key={index} className="flex items-start gap-3 group" data-id="element-34">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300" data-id="element-35">
                    {item.icon}
                  </div>
                  <span className="text-charcoal font-medium pt-2" data-id="element-36">
                    {item.text}
                  </span>
                </div>)}
            </div>

            <div className="animate-fadeInUp animation-delay-500" data-id="element-37">
              <Link to="/about" data-id="element-38">
                <Button variant="outline" size="lg" data-id="element-39">
                  Learn More About Us
                </Button>
              </Link>
            </div>
          </div>

          {/* Image - Senator's Formal Portrait */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2 relative animate-fadeInRight" data-id="element-40">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-41">
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/60 via-transparent to-transparent z-10" data-id="element-42" />
              <img src="https://cdn.magicpatterns.com/uploads/bbEknxtjSFBKULaAfMFH6V/674f1612-c4d6-4931-84d9-dd37fd86f516.jpg" alt="Senator Fatimat Raji Rasaki - Founder of SFRR Foundation" className="w-full h-[600px] lg:h-[700px] object-cover object-center" loading="lazy" width="600" height="700" data-id="element-43" />

              {/* Info Card Overlay */}
              <div className="absolute bottom-8 left-8 right-8 z-20" data-id="element-44">
                <div className="bg-white/95 backdrop-blur-md p-6 rounded-2xl shadow-xl border border-white/50" data-id="element-45">
                  <div className="flex items-start gap-4" data-id="element-46">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-47">
                      <Award className="w-6 h-6 text-primary" data-id="element-48" />
                    </div>
                    <div data-id="element-49">
                      <p className="font-serif font-bold text-xl text-charcoal mb-1" data-id="element-50">
                        Senator Fatimat Raji Rasaki
                      </p>
                      <p className="text-sm text-neutral-600 mb-2" data-id="element-51">
                        Founder & Visionary Leader
                      </p>
                      <p className="text-xs text-neutral-500 leading-relaxed" data-id="element-52">
                        Leading with compassion and commitment to create lasting
                        change across Nigeria through humanitarian service and
                        community empowerment.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -z-10 -top-6 -right-6 w-72 h-72 bg-primary/10 rounded-full blur-3xl" aria-hidden="true" data-id="element-53" />
            <div className="absolute -z-10 -bottom-6 -left-6 w-72 h-72 bg-secondary/10 rounded-full blur-3xl" aria-hidden="true" data-id="element-54" />
          </div>
        </div>
      </div>
    </section>;
}